import { createSlice } from "@reduxjs/toolkit";
import { InsightshubIcon } from "assets/images/icons";

interface EventTrackingState {
    eventTrackingMetricDetails: any[];
    filteredMetricDetails: any[];
    eventDetails: any[];
    miniCardDetails: any[];
    filterDetails: any[];
    selectedFilters: Record<string, any>;
    chartDetails: any[];
    filteredChartDetails: any[],
    renderingChartDetails: any[],
    insights: any[],
    filteredInsights: any[],
    renderingInsights: any[],
    catFoodMetrics: any[],
    miniCatCardDetails: any[],
    dogFoodMetrics: any[],
    miniDogCardDetails: any[]
}

const initialState: EventTrackingState = {
    eventTrackingMetricDetails: [], // Metric details in event tracking page
    filteredMetricDetails: [], // Filtered metric details. Whenever this is updated we will update miniCardDetails
    eventDetails: [], // event details
    miniCardDetails: [], // Mini Crad details that will be displayed
    filterDetails: [], // all filters for event Tracking Page
    selectedFilters: {},
    chartDetails: [],
    filteredChartDetails: [],
    renderingChartDetails: [],
    insights: [],
    filteredInsights: [],
    renderingInsights: [],
    catFoodMetrics: [],
    miniCatCardDetails: [],
    dogFoodMetrics: [],
    miniDogCardDetails: []
};

const eventTrackingSlice = createSlice({
    name: "eventTracking",
    initialState,
    reducers: {
        setMiniCardDetails: (state, action) => {
            const metricDetails = Array.isArray(action.payload)
                ? action.payload
                : [];

            //   const activeSegment = state.activeSegment;
            const parentId = 1
            console.log("Parent ID for Active Segment:", parentId);

            if (!parentId) {
                state.miniCardDetails = [];
                return;
            }

            const filteredMetrics = metricDetails
                .filter(
                    (metric) => metric.parent_id === parentId && (metric.display_order ?? 0) !== 0
                )
                .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));

            console.log("Filtered Event Metrics for Mini Cards:", filteredMetrics);

            // ---- NEW CLEANER FUNCTION ADDED HERE ----
            const cleanRatioUnit = (unit = "") => {
                const normalized = unit.replace(/\s+/g, ""); // remove spaces

                if (normalized.startsWith("ratio")) {
                    // remove “ratio” and keep what follows (like /5)
                    return normalized.replace("ratio", "");
                }
                return unit;
            };
            // -----------------------------------------

            const formatNumberSmart = (num: string | null | undefined) => {
                if (num === null || num === undefined || num === "") return "";

                const n = Number(num);
                const fixed = n.toFixed(2);

                // If .00 → display integer
                if (fixed.endsWith(".00")) {
                    return String(parseInt(fixed, 10));
                }

                return fixed; // Always two decimals
            };

            const formattedMiniCards = filteredMetrics.map((metric) => {
                // Get units
                let prefixUnit =
                    metric.units?.find((u: { prefix: boolean; }) => u.prefix === true)?.unit || "";
                let suffixUnit =
                    metric.units?.find((u: { prefix: boolean; }) => u.prefix === false)?.unit || "";

                // ---- CLEAN BEFORE USING ----
                prefixUnit = cleanRatioUnit(prefixUnit);
                suffixUnit = cleanRatioUnit(suffixUnit);

                const roundedValue = formatNumberSmart(metric.value);
                const value = `${prefixUnit} ${roundedValue} ${suffixUnit}`;

                // Delta units
                let deltaPrefix =
                    metric.delta?.unit?.find((u: any) => u.prefix === true)?.unit || "";
                let deltaSuffix =
                    metric.delta?.unit?.find((u: any) => u.prefix === false)?.unit || "";

                deltaPrefix = cleanRatioUnit(deltaPrefix);
                deltaSuffix = cleanRatioUnit(deltaSuffix);

                const deltaTimeMarker = metric.delta?.time_marker ?? "";
                // const deltaTimeMarker = "";
                const roundedValue2 = formatNumberSmart(metric.delta?.value ?? "");
                const change = `${deltaPrefix}${roundedValue2}${deltaSuffix} ${deltaTimeMarker}`;

                return {
                    label: metric.name,
                    value,
                    trend: metric.delta?.trend ?? "",
                    change,
                    timeMarker: metric.time_marker ?? "",
                    source: metric.source
                };
            });

            state.miniCardDetails = formattedMiniCards;
        },

        setCatFoodMetrics: (state, action) => {
            state.catFoodMetrics = action.payload;
        },

        setMiniCatCardDetails: (state, action) => {
            const metricDetails = Array.isArray(action.payload)
                ? action.payload
                : [];

            //   const activeSegment = state.activeSegment;
            const parentId = 1
            console.log("Parent ID for Active Segment:", parentId);

            if (!parentId) {
                state.miniCardDetails = [];
                return;
            }

            const filteredMetrics = metricDetails
                .filter(
                    (metric) => metric.parent_id === parentId && (metric.display_order ?? 0) !== 0
                )
                .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));

            console.log("Filtered Event Metrics for Mini Cards:", filteredMetrics);

            // ---- NEW CLEANER FUNCTION ADDED HERE ----
            const cleanRatioUnit = (unit = "") => {
                const normalized = unit.replace(/\s+/g, ""); // remove spaces

                if (normalized.startsWith("ratio")) {
                    // remove “ratio” and keep what follows (like /5)
                    return normalized.replace("ratio", "");
                }
                return unit;
            };
            // -----------------------------------------

            const formatNumberSmart = (num: string | null | undefined) => {
                if (num === null || num === undefined || num === "") return "";

                const n = Number(num);
                const fixed = n.toFixed(2);

                // If .00 → display integer
                if (fixed.endsWith(".00")) {
                    return String(parseInt(fixed, 10));
                }

                return fixed; // Always two decimals
            };

            const formattedMiniCards = filteredMetrics.map((metric) => {
                // Get units
                let prefixUnit =
                    metric.units?.find((u: { prefix: boolean; }) => u.prefix === true)?.unit || "";
                let suffixUnit =
                    metric.units?.find((u: { prefix: boolean; }) => u.prefix === false)?.unit || "";

                // ---- CLEAN BEFORE USING ----
                prefixUnit = cleanRatioUnit(prefixUnit);
                suffixUnit = cleanRatioUnit(suffixUnit);

                const roundedValue = formatNumberSmart(metric.value);
                const value = `${prefixUnit} ${roundedValue} ${suffixUnit}`;

                // Delta units
                let deltaPrefix =
                    metric.delta?.unit?.find((u: any) => u.prefix === true)?.unit || "";
                let deltaSuffix =
                    metric.delta?.unit?.find((u: any) => u.prefix === false)?.unit || "";

                deltaPrefix = cleanRatioUnit(deltaPrefix);
                deltaSuffix = cleanRatioUnit(deltaSuffix);

                const deltaTimeMarker = metric.delta?.time_marker ?? "";
                // const deltaTimeMarker = "";
                const roundedValue2 = formatNumberSmart(metric.delta?.value ?? "");
                const change = `${deltaPrefix}${roundedValue2}${deltaSuffix} ${deltaTimeMarker}`;

                return {
                    label: metric.name,
                    value,
                    trend: metric.delta?.trend ?? "",
                    change,
                    timeMarker: metric.time_marker ?? "",
                    source: metric.source
                };
            });

            state.miniCatCardDetails = formattedMiniCards;
        },

        setDogFoodMetrics: (state, action) => {
            state.dogFoodMetrics = action.payload;
        },

        setMiniDogCardDetails: (state, action) => {
            const metricDetails = Array.isArray(action.payload)
                ? action.payload
                : [];

            //   const activeSegment = state.activeSegment;
            const parentId = 1
            console.log("Parent ID for Active Segment:", parentId);

            if (!parentId) {
                state.miniCardDetails = [];
                return;
            }

            const filteredMetrics = metricDetails
                .filter(
                    (metric) => metric.parent_id === parentId && (metric.display_order ?? 0) !== 0
                )
                .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));

            console.log("Filtered Event Metrics for Mini Cards:", filteredMetrics);

            // ---- NEW CLEANER FUNCTION ADDED HERE ----
            const cleanRatioUnit = (unit = "") => {
                const normalized = unit.replace(/\s+/g, ""); // remove spaces

                if (normalized.startsWith("ratio")) {
                    // remove “ratio” and keep what follows (like /5)
                    return normalized.replace("ratio", "");
                }
                return unit;
            };
            // -----------------------------------------

            const formatNumberSmart = (num: string | null | undefined) => {
                if (num === null || num === undefined || num === "") return "";

                const n = Number(num);
                const fixed = n.toFixed(2);

                // If .00 → display integer
                if (fixed.endsWith(".00")) {
                    return String(parseInt(fixed, 10));
                }

                return fixed; // Always two decimals
            };

            const formattedMiniCards = filteredMetrics.map((metric) => {
                // Get units
                let prefixUnit =
                    metric.units?.find((u: { prefix: boolean; }) => u.prefix === true)?.unit || "";
                let suffixUnit =
                    metric.units?.find((u: { prefix: boolean; }) => u.prefix === false)?.unit || "";

                // ---- CLEAN BEFORE USING ----
                prefixUnit = cleanRatioUnit(prefixUnit);
                suffixUnit = cleanRatioUnit(suffixUnit);

                const roundedValue = formatNumberSmart(metric.value);
                const value = `${prefixUnit} ${roundedValue} ${suffixUnit}`;

                // Delta units
                let deltaPrefix =
                    metric.delta?.unit?.find((u: any) => u.prefix === true)?.unit || "";
                let deltaSuffix =
                    metric.delta?.unit?.find((u: any) => u.prefix === false)?.unit || "";

                deltaPrefix = cleanRatioUnit(deltaPrefix);
                deltaSuffix = cleanRatioUnit(deltaSuffix);

                const deltaTimeMarker = metric.delta?.time_marker ?? "";
                // const deltaTimeMarker = "";
                const roundedValue2 = formatNumberSmart(metric.delta?.value ?? "");
                const change = `${deltaPrefix}${roundedValue2}${deltaSuffix} ${deltaTimeMarker}`;

                return {
                    label: metric.name,
                    value,
                    trend: metric.delta?.trend ?? "",
                    change,
                    timeMarker: metric.time_marker ?? "",
                    source: metric.source
                };
            });

            state.miniDogCardDetails = formattedMiniCards;
        },

        setInsights: (state, action) => {
            state.insights = action.payload;
        },

        setFilteredInsights: (state, action) => {
            state.filteredInsights = action.payload;
        },

        setRenderingEventInsights: (state, action) => {
            const insights = action.payload
            console.log("Filterd Insights Events", insights)
            state.renderingInsights = insights[0]?.observations[0]?.text;
        },

        setEventDetails: (state, action) => {
            state.eventDetails = action.payload;
        },

        setEventTrackingMetricDetails: (state, action) => {
            state.eventTrackingMetricDetails = action.payload;
        },

        setEventFilteredMetrics: (state, action) => {
            console.log("Setting Filter Details:", action.payload);
            state.filteredMetricDetails = action.payload;
        },

        setEventFilterDetails: (state, action) => {
            state.filterDetails = action.payload;
        },

        setSelectedFilter: (state, action) => {
            const { title, value } = action.payload;
            state.selectedFilters[title] = value;
        },

        setResetSlectedFilters: (state) => {
            state.selectedFilters = {};
        },

        setChartDetails: (state, action) => {
            state.chartDetails = action.payload;
        },

        setFilteredChartDetails: (state, action) => {
            state.filteredChartDetails = action.payload;
        },

        setRenderingChartDetails: (state, action) => {
            const chartDetails = Array.isArray(action.payload)
                ? action.payload
                : [];

            const parentId = 1
            const filteredCharts = chartDetails
                .filter((chart) => chart.parent_id === parentId)
                .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));

            console.log("Filtered Metrics for ChartDetails:", filteredCharts);
            state.renderingChartDetails = filteredCharts;
        }


    },
});

export const {
    setEventDetails,
    setEventTrackingMetricDetails,
    setMiniCardDetails,
    setEventFilteredMetrics,
    setEventFilterDetails,
    setSelectedFilter,
    setResetSlectedFilters,
    setChartDetails,
    setFilteredChartDetails,
    setRenderingChartDetails,
    setInsights,
    setFilteredInsights,
    setRenderingEventInsights,
    setCatFoodMetrics,
    setMiniCatCardDetails,
    setDogFoodMetrics,
    setMiniDogCardDetails
} = eventTrackingSlice.actions;

export default eventTrackingSlice.reducer;

